import React from 'react'
import { Typography } from '@mui/material'

export interface FieldLabelProps {
  children: React.ReactNode
  /** Append a ` *` required marker after the label text. */
  required?: boolean
}

/**
 * Bold caption rendered above a field - the admin add/edit form's external
 * label convention (label-at-top, not MUI's floating `label`/`InputLabel`).
 * Pair every titled input with one of these so labelling is uniform across
 * forms. Was previously inlined in `ExceptionTypeForm`.
 */
const FieldLabel: React.FC<FieldLabelProps> = ({ children, required = false }) => (
  <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
    {children}
    {required ? ' *' : ''}
  </Typography>
)

export default FieldLabel
